import { ProjectCreateButton } from "./project.create.button";
import { ProjectCreateForm } from "./project.create.form";

export const ProjectCreate = {
    Button: ProjectCreateButton,
    Component: ProjectCreateForm,
}
